import { render } from "./ChangePassword.vue?vue&type=template&id=5d0921be&scoped=true"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"

import "./ChangePassword.vue?vue&type=style&index=0&id=5d0921be&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashcam_front/dashcam_front/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d0921be"]])

export default __exports__